<template>
  <div>
    <el-button
      type="warning"
      :style="{ background: backgroundColor, color: fontColor }"
    >
      <div class="feather">
        <img class="feather-img" :src="imageUrl" />
        <div>
          <div>
            <slot name="title"></slot>
          </div>
        </div>
      </div>
    </el-button>
  </div>
</template>

<script>
export default {
  props: {
    backgroundColor: String,
    fontColor: String,
    imageUrl: String,
    
  },
  data() {
    return {
    };
  },
  
  mounted() {
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.el-button {
  margin-top: 21px;
  background: red;
  padding-right: 80px;
  font-size: 14px;
  height: 42px;
}
::v-deep {
  .el-button--primary {
    border-color: white;
  }
}

.feather {
  display: flex;
  align-items: center;
}
.feather-img {
  display: block;
  width: 10px;
  height: 10px;
  margin-right: 20px;
}
</style>